/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { getActiveLocale } from './locale';

export const isoToStringDateFormat = function (isoString: string, locale?: string): string {
  // TIP: Input => "2025-06-12T05:13:19.774815Z"

  if (!isoString) return '';

  const dateObject = new Date(isoString);
  // return empty string if date is invalid
  if (isNaN(dateObject.getTime())) return '';
 
  const activeLocale = getActiveLocale(locale);
  const formattedDate = new Intl.DateTimeFormat(activeLocale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(dateObject);

  //   TIP: Output => "22 May 2025 11:11:11 PM"
  return formattedDate;
};

export const formatDateTo2DigitDayAndMonthWithYear = (
  dateTime: string | number | null | undefined,
  opts?: { format?: 'dd-mmm-yyyy' | 'dd/mm/yy hh:mm aa' },
  locale?: string
): string => {
  if (!dateTime) {
    return 'Default';
  }

  const date = new Date(dateTime);

  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  const activeLocale = getActiveLocale(locale);

  if (opts?.format === 'dd/mm/yy hh:mm aa') {
    return new Intl.DateTimeFormat(activeLocale, {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

  // Default: 2-digit day, short month, full year
  return date
    .toLocaleDateString(activeLocale, {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
    .replace(',', '');
};

export const formatDateMonthDayYearTime = (
  dateTime: string | number | null | undefined,
  locale?: string
): string => {
  if (!dateTime) {
    return 'Default';
  }

  const date = new Date(dateTime);

  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  const activeLocale = getActiveLocale(locale);
  return new Intl.DateTimeFormat(activeLocale, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
};
